import { atomWithLocalStorage } from '@/context/atoms/helper/atomWithLocalStorage';

export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system',
}

export const themeModeAtom = atomWithLocalStorage<ThemeMode>('EKKO_WORKERUI_THEME', ThemeMode.LIGHT);
